// extracted by mini-css-extract-plugin
export default {"input":"input_input__abwhw","input--error":"input_input--error__kSAlo","input--large":"input_input--large__zzg3A","input--small":"input_input--small__X3BPE"};